const POSITION_CLASSES = ["relative", "absolute", "fixed", "sticky"];

/** Class combiner (plain join) with one safety rule: position utilities are
 *  de-duplicated so the LAST one wins. Without this, a component's default
 *  `relative` plus a caller's `absolute` would both be emitted and the
 *  stylesheet order — not the caller's intent — would decide. That silently
 *  breaks absolutely-positioned elements (e.g. the copy button that must sit
 *  in the top-right corner of a code block). */
export function cn(...inputs: (string | false | null | undefined)[]) {
  const joined = inputs.filter(Boolean).join(" ");
  const tokens = joined.split(" ");
  const present = POSITION_CLASSES.filter((c) => tokens.indexOf(c) !== -1);
  if (present.length <= 1) return joined;
  const drop = present.slice(0, -1);
  return tokens.filter((t) => drop.indexOf(t) === -1).join(" ");
}
